import FormattedMessage from 'I18n/components/FormattedMessage';
import { AlertDanger, Body, Button, Caption, Heading, IconContainer, LayoutHorizontal, LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { WarningIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UsageError = ({
  onRefresh
}) => {
  return /*#__PURE__*/_jsx(AlertDanger, {
    blockSize: "6.25rem",
    paddingBlock: "space-xs",
    children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      gap: "space-xs",
      children: [/*#__PURE__*/_jsxs(LayoutSpaceVertical, {
        gap: "space-xxs",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h6",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "hubSpotCredits.error.title"
          })
        }), /*#__PURE__*/_jsx(Body, {
          as: "div",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "hubSpotCredits.error.description"
          })
        })]
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onRefresh,
        size: "xs",
        variant: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubSpotCredits.error.cta"
        })
      })]
    })
  });
};
export const UsageErrorPanel = ({
  onRefresh
}) => {
  return /*#__PURE__*/_jsxs(LayoutHorizontal, {
    gap: "space",
    children: [/*#__PURE__*/_jsxs(LayoutHorizontal, {
      gap: "space-xxs",
      children: [/*#__PURE__*/_jsx(IconContainer, {
        variant: "danger",
        children: /*#__PURE__*/_jsx(WarningIcon, {})
      }), /*#__PURE__*/_jsx(Caption, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubSpotCredits.error.description"
        })
      })]
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onRefresh,
      size: "xs",
      variant: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.error.cta"
      })
    })]
  });
};